import React, { useEffect, useState } from 'react'
import "react-data-table-component-extensions/dist/index.css";
import { useDispatch, useSelector } from 'react-redux';
import { departmentListRes, departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList';
import PropagateLoader from "react-spinners/PropagateLoader";
import DataTables from '../LMS_DATA_TABLE/DataTable';

export default function Department() {

    const dispatch = useDispatch()
    const data = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
    const [loading, setLoading] = useState(false)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'DEPARTMENT NAME',
            field: 'vdepartment_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'MANAGER',
            field: 'vdept_manager_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EMPLOYEE',
            field: 'icount_employee',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'vstatus',
            cellRenderer: params => <span className={params.value == 'Active' ? 'badge text-bg-success' : 'badge text-bg-danger'}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'vcreated_date',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     field: 'Actions',
        //     cellRenderer: Action
        // }
    ]);

    const dept_res = () => {
        if (departmentListRes && departmentListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(departmentListTodo()).then(() => dept_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>Department List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }

            </div>
        </>
    )
}
